import React from "react";
import EnquiryList from "./EnquiryList";

export default function AssignEnquiryList() {
  return (
    <section>
      <EnquiryList api="assignenquirylist" />
    </section>
  );
}
